var _path, _g, _path2, _path3, _path4, _path5, _g2, _path6, _path7, _path8, _path9, _g3, _path0, _path1, _path10, _path11, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup26795(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 140,
    viewBox: "0 0 200 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M162 0H42C36.4772 0 32 4.47715 32 10V130C32 135.523 36.4772 140 42 140H162C167.523 140 172 135.523 172 130V10C172 4.47715 167.523 0 162 0Z",
    fill: "url(#paint0_linear_2750_70416)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2750_70416)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146 10H11C8.23858 10 6 12.2386 6 15V40C6 42.7614 8.23858 45 11 45H146C148.761 45 151 42.7614 151 40V15C151 12.2386 148.761 10 146 10Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75 18H49C47.3431 18 46 19.3431 46 21C46 22.6569 47.3431 24 49 24H75C76.6569 24 78 22.6569 78 21C78 19.3431 76.6569 18 75 18Z",
    fill: "#B4DAFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M93 31H49C47.3431 31 46 32.3431 46 34C46 35.6569 47.3431 37 49 37H93C94.6569 37 96 35.6569 96 34C96 32.3431 94.6569 31 93 31Z",
    fill: "#DEE9FC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33 13H14C11.2386 13 9 15.2386 9 18V37C9 39.7614 11.2386 42 14 42H33C35.7614 42 38 39.7614 38 37V18C38 15.2386 35.7614 13 33 13Z",
    fill: "#1485FD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.222 30.78H23.222L23.244 30.01C23.244 28.998 23.882 28.734 24.784 28.448C25.6888 28.1906 26.4852 27.6456 27.0528 26.8955C27.6204 26.1453 27.9283 25.2307 27.93 24.29C27.9498 23.7157 27.8502 23.1435 27.6374 22.6096C27.4246 22.0758 27.1033 21.5919 26.6939 21.1886C26.2844 20.7854 25.7957 20.4715 25.2586 20.2669C24.7216 20.0623 24.148 19.9714 23.574 20C22.9674 19.9868 22.3644 20.0969 21.8017 20.3237C21.2389 20.5505 20.7281 20.8893 20.3002 21.3194C19.8723 21.7495 19.5363 22.2621 19.3124 22.8261C19.0886 23.39 18.9816 23.9935 18.998 24.6H21.066C21.0581 24.2651 21.1172 23.9321 21.2397 23.6203C21.3623 23.3085 21.5458 23.0244 21.7796 22.7845C22.0133 22.5445 22.2926 22.3537 22.6011 22.2231C22.9096 22.0925 23.241 22.0248 23.576 22.024C23.8781 22.0065 24.1804 22.0542 24.4623 22.1639C24.7443 22.2737 24.9994 22.4428 25.2102 22.6599C25.421 22.8769 25.5826 23.1368 25.684 23.4219C25.7855 23.707 25.8243 24.0106 25.798 24.312C25.7847 24.7999 25.615 25.2706 25.314 25.6548C25.013 26.039 24.5965 26.3164 24.126 26.446L23.4 26.734C22.6892 26.9053 22.0686 27.3372 21.6612 27.9443C21.2538 28.5514 21.0891 29.2893 21.2 30.012L21.222 30.78ZM22.212 35.534C22.4078 35.541 22.6031 35.5086 22.7862 35.4388C22.9693 35.369 23.1366 35.2632 23.2781 35.1276C23.4196 34.9921 23.5325 34.8295 23.6101 34.6496C23.6877 34.4696 23.7285 34.276 23.73 34.08C23.7282 33.8842 23.6873 33.6908 23.6095 33.5111C23.5318 33.3313 23.4189 33.169 23.2774 33.0337C23.1359 32.8984 22.9687 32.7927 22.7857 32.723C22.6027 32.6534 22.4076 32.6211 22.212 32.628C22.0163 32.6211 21.8212 32.6534 21.6382 32.723C21.4552 32.7927 21.2881 32.8984 21.1466 33.0337C21.0051 33.169 20.8921 33.3313 20.8144 33.5111C20.7367 33.6908 20.6957 33.8842 20.694 34.08C20.6955 34.276 20.7362 34.4696 20.8138 34.6496C20.8914 34.8295 21.0044 34.9921 21.1459 35.1276C21.2874 35.2632 21.4547 35.369 21.6378 35.4388C21.8209 35.5086 22.0161 35.541 22.212 35.534Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2750_70416)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54 53H189C190.326 53 191.598 53.5268 192.536 54.4645C193.473 55.4021 194 56.6739 194 58V83C194 84.3261 193.473 85.5979 192.536 86.5355C191.598 87.4732 190.326 88 189 88H54C52.6739 88 51.4021 87.4732 50.4645 86.5355C49.5268 85.5979 49 84.3261 49 83V58C49 56.6739 49.5268 55.4021 50.4645 54.4645C51.4021 53.5268 52.6739 53 54 53V53Z",
    fill: "white"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M118 61H92C90.3431 61 89 62.3431 89 64C89 65.6569 90.3431 67 92 67H118C119.657 67 121 65.6569 121 64C121 62.3431 119.657 61 118 61Z",
    fill: "#B4DAFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M136 74H92C90.3431 74 89 75.3431 89 77C89 78.6569 90.3431 80 92 80H136C137.657 80 139 78.6569 139 77C139 75.3431 137.657 74 136 74Z",
    fill: "#DEE9FC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M76 56H57C54.2386 56 52 58.2386 52 61V80C52 82.7614 54.2386 85 57 85H76C78.7614 85 81 82.7614 81 80V61C81 58.2386 78.7614 56 76 56Z",
    fill: "#1485FD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M64.222 73.78H66.222L66.244 73.01C66.244 71.998 66.882 71.734 67.784 71.448C68.6888 71.1906 69.4852 70.6456 70.0528 69.8955C70.6204 69.1453 70.9283 68.2307 70.93 67.29C70.9498 66.7157 70.8502 66.1435 70.6374 65.6096C70.4246 65.0758 70.1033 64.5919 69.6939 64.1886C69.2844 63.7854 68.7957 63.4715 68.2586 63.2669C67.7216 63.0623 67.148 62.9714 66.574 63C65.9674 62.9868 65.3644 63.0969 64.8017 63.3237C64.2389 63.5505 63.7281 63.8893 63.3002 64.3194C62.8723 64.7495 62.5363 65.2621 62.3124 65.8261C62.0886 66.39 61.9816 66.9935 61.998 67.6H64.066C64.0581 67.2651 64.1172 66.9321 64.2397 66.6203C64.3623 66.3085 64.5458 66.0244 64.7796 65.7845C65.0133 65.5445 65.2926 65.3537 65.6011 65.2231C65.9096 65.0925 66.241 65.0248 66.576 65.024C66.8781 65.0065 67.1804 65.0542 67.4623 65.1639C67.7443 65.2737 67.9994 65.4428 68.2102 65.6599C68.421 65.8769 68.5826 66.1368 68.684 66.4219C68.7855 66.707 68.8243 67.0106 68.798 67.312C68.7847 67.7999 68.615 68.2706 68.314 68.6548C68.013 69.039 67.5965 69.3164 67.126 69.446L66.4 69.734C65.6892 69.9053 65.0686 70.3372 64.6612 70.9443C64.2538 71.5514 64.0891 72.2893 64.2 73.012L64.222 73.78ZM65.212 78.534C65.4078 78.541 65.6031 78.5086 65.7862 78.4388C65.9693 78.369 66.1366 78.2632 66.2781 78.1276C66.4196 77.9921 66.5325 77.8295 66.6101 77.6496C66.6877 77.4696 66.7285 77.276 66.73 77.08C66.7282 76.8842 66.6873 76.6908 66.6095 76.5111C66.5318 76.3313 66.4189 76.169 66.2774 76.0337C66.1359 75.8984 65.9687 75.7927 65.7857 75.723C65.6027 75.6534 65.4076 75.6211 65.212 75.628C65.0163 75.6211 64.8212 75.6534 64.6382 75.723C64.4552 75.7927 64.2881 75.8984 64.1466 76.0337C64.0051 76.169 63.8921 76.3313 63.8144 76.5111C63.7367 76.6908 63.6957 76.8842 63.694 77.08C63.6955 77.276 63.7362 77.4696 63.8138 77.6496C63.8914 77.8295 64.0044 77.9921 64.1459 78.1276C64.2874 78.2632 64.4547 78.369 64.6378 78.4388C64.8209 78.5086 65.0161 78.541 65.212 78.534Z",
    fill: "white"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2750_70416)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 96H146C147.326 96 148.598 96.5268 149.536 97.4645C150.473 98.4021 151 99.6739 151 101V126C151 127.326 150.473 128.598 149.536 129.536C148.598 130.473 147.326 131 146 131H11C9.67392 131 8.40215 130.473 7.46447 129.536C6.52678 128.598 6 127.326 6 126V101C6 99.6739 6.52678 98.4021 7.46447 97.4645C8.40215 96.5268 9.67392 96 11 96V96Z",
    fill: "white"
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M75 104H49C47.3431 104 46 105.343 46 107C46 108.657 47.3431 110 49 110H75C76.6569 110 78 108.657 78 107C78 105.343 76.6569 104 75 104Z",
    fill: "#B4DAFF"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M93 117H49C47.3431 117 46 118.343 46 120C46 121.657 47.3431 123 49 123H93C94.6569 123 96 121.657 96 120C96 118.343 94.6569 117 93 117Z",
    fill: "#DEE9FC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M33 99H14C11.2386 99 9 101.239 9 104V123C9 125.761 11.2386 128 14 128H33C35.7614 128 38 125.761 38 123V104C38 101.239 35.7614 99 33 99Z",
    fill: "#1485FD"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21.222 116.78H23.222L23.244 116.01C23.244 114.998 23.882 114.734 24.784 114.448C25.6888 114.191 26.4852 113.646 27.0528 112.895C27.6204 112.145 27.9283 111.231 27.93 110.29C27.9498 109.716 27.8502 109.143 27.6374 108.61C27.4246 108.076 27.1033 107.592 26.6939 107.189C26.2844 106.785 25.7957 106.472 25.2586 106.267C24.7216 106.062 24.148 105.971 23.574 106C22.9674 105.987 22.3644 106.097 21.8017 106.324C21.2389 106.551 20.7281 106.889 20.3002 107.319C19.8723 107.75 19.5363 108.262 19.3124 108.826C19.0886 109.39 18.9816 109.993 18.998 110.6H21.066C21.0581 110.265 21.1172 109.932 21.2397 109.62C21.3623 109.309 21.5458 109.024 21.7796 108.784C22.0133 108.545 22.2926 108.354 22.6011 108.223C22.9096 108.093 23.241 108.025 23.576 108.024C23.8781 108.006 24.1804 108.054 24.4623 108.164C24.7443 108.274 24.9994 108.443 25.2102 108.66C25.421 108.877 25.5826 109.137 25.684 109.422C25.7855 109.707 25.8243 110.011 25.798 110.312C25.7847 110.8 25.615 111.271 25.314 111.655C25.013 112.039 24.5965 112.316 24.126 112.446L23.4 112.734C22.6892 112.905 22.0686 113.337 21.6612 113.944C21.2538 114.551 21.0891 115.289 21.2 116.012L21.222 116.78ZM22.212 121.534C22.4078 121.541 22.6031 121.509 22.7862 121.439C22.9693 121.369 23.1366 121.263 23.2781 121.128C23.4196 120.992 23.5325 120.83 23.6101 120.65C23.6877 120.47 23.7285 120.276 23.73 120.08C23.7282 119.884 23.6873 119.691 23.6095 119.511C23.5318 119.331 23.4189 119.169 23.2774 119.034C23.1359 118.898 22.9687 118.793 22.7857 118.723C22.6027 118.653 22.4076 118.621 22.212 118.628C22.0163 118.621 21.8212 118.653 21.6382 118.723C21.4552 118.793 21.2881 118.898 21.1466 119.034C21.0051 119.169 20.8921 119.331 20.8144 119.511C20.7367 119.691 20.6957 119.884 20.694 120.08C20.6955 120.276 20.7362 120.47 20.8138 120.65C20.8914 120.83 21.0044 120.992 21.1459 121.128C21.2874 121.263 21.4547 121.369 21.6378 121.439C21.8209 121.509 22.0161 121.541 22.212 121.534Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2750_70416",
    x: 0,
    y: 7,
    width: 157,
    height: 47,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2750_70416"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2750_70416",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2750_70416",
    x: 43,
    y: 50,
    width: 157,
    height: 47,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2750_70416"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2750_70416",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2750_70416",
    x: 0,
    y: 93,
    width: 157,
    height: 47,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2750_70416"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2750_70416",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2750_70416",
    x1: 102,
    y1: 0,
    x2: 102,
    y2: 140,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3ECFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAE7FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup26795);
export default __webpack_public_path__ + "static/media/Group26795.91d00b3bc26e7558d88458afb64d61c5.svg";
export { ForwardRef as ReactComponent };